<template>
  <div class="wechat-login">
    <div class="title">
      <span @click="backClick">
        <iconfont
          style="cursor: pointer;"
          name="#icon-left"
          font-size="12px"
        > </iconfont>
      </span>
      微信扫码，关注公众号登录
    </div>
    <div
      v-loading="!weChatImgUrl"
      class="login-qrcode"
      @click="getWeChatURL"
    >
      <img
        v-if="weChatImgUrl"
        :src="weChatImgUrl"
        title="点击刷新二维码"
      >
    </div>
  </div>
</template>
<script>
/* eslint-disable */
import { mapMutations } from 'vuex'
export default {
  props: {
    status: {
      type: Boolean,
      default: false
    },
    checkUnreadInfo: {
      type: Function,
      default: () => {
        return null
      }
    },
    checkLoginTimes: {
      type: Function,
      default: () => {
        return null
      }
    },
    autoToTool: {
      type: Function,
      default: () => {
        return null
      }
    }
  },
  data() {
    return {
      weChatImgUrl: '',
      wechatLoginStatus: null
    }
  },
  watch: {
    status: {
      immediate: true,
      handler: function(val, old) {
        if (val) {
          this.getWeChatURL()
        } else {
          clearInterval(this.wechatLoginStatus)
        }
      }
    }
  },
  mounted() {
    this.getWeChatURL()
  },
  methods: {
    ...mapMutations(['changeLogin']),
    //获取微信登录二维码
    getWeChatURL() {
      const source = (this.$store.getters['sensors/registerSuccessSource'] || {}).name || '非指定来源'
      this.$http.get('/login/rha').then(({ data }) => {
        if (data.code == 200) {
          this.weChatImgUrl = `${data.data.url}&state=${source}`
          clearInterval(this.wechatLoginStatus)
          this.wechatLoginStatus = setInterval(() => {
            this.getWeChatSession(data.data.ticket)
          }, 1000)
        }
      })
    },
    //检测是否已经扫描登录成功
    getWeChatSession(ticket) {
      this.$http
        .post('/session/set', {
          ticket: ticket
        })
        .then(({ data }) => {
          // console.log("data:", data);
          if (data.code == 200) {
            if (data.data) {
              clearInterval(this.wechatLoginStatus)
              this.changeLogin(data.data)
              this.checkLoginTimes(data.data)
              this.autoToTool()
              this.checkUnreadInfo()
              this.$emit('loginSucc')
            }
          }
        })
    },
    // 返回按钮
    backClick() {
      console.log('返回')
      this.$emit('backClick')
    }
  }
}
</script>
<style lang="scss" scoped>
.wechat-login {
  background-color: #fff;
  box-sizing: border-box;
  letter-spacing: 0px;
  .title {
    font-size: 18px;
    font-family: Microsoft YaHei;
    font-weight: 400;
    text-align: left;
  }
  .login-qrcode {
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto;
    margin-top: 35px;
    width: 176px;
    height: 176px;
    border: 1px solid #e4e4e4;
    box-sizing: border-box;
    img {
      width: calc(176px - 11px);
      height: calc(176px - 11px);
    }
  }
  .login-line {
    position: relative;
    margin-top: 40px;
    margin-bottom: 21px;
    line-height: 14px;
    font-size: 14px;
    color: #999999;
    &::after {
      position: absolute;
      width: 92px;
      height: 2px;
      right: 0px;
      bottom: 50%;
      content: '';
      background-color: #e4e4e4;
    }
    &::before {
      position: absolute;
      width: 92px;
      height: 2px;
      left: 0px;
      bottom: 50%;
      content: '';
      background-color: #e4e4e4;
    }
  }
  .other-login {
    display: flex;
    position: relative;
    margin: 35px 0 37px;
    padding: 0px 40px 0 40px;
    justify-content: space-around;
    .option {
      display: flex;
      justify-content: center;
      align-items: center;
      width: 58px;
      height: 58px;
      border-radius: 50%;
      border: 1px solid #e4e4e4;
      img {
        width: 40px;
        height: 40px;
        cursor: pointer;
        opacity: 0.6;
        &:hover {
          opacity: 1;
        }
      }
    }
  }
}
</style>
